module.exports = __webpack_public_path__ + "img/20.d60945eb.png";